import React from 'react';
import InboxMenu from '../InboxMenu/InboxMenu';
import { checkUserPermission } from 'src/helpers/validationHelper';
import { useSelector } from 'react-redux';
import { USER_ROLES } from 'src/common/constants';
import './inbox-header.scss';

const InboxHeader = ({ type, onSelectType }) => {
  const messageType = type === 'Messages' ? 'active' : '';
  const announcementType = type === 'Announcements' ? 'active' : '';
  const permission = useSelector((state: any) => state.tabSelections);

  const { allowedTabList } = permission;

  let showAnnouncementsForHomeowner = allowedTabList.filter(
    (permission) => permission.name === 'Announcements'
  )[0];

  const showAnnouncement = checkUserPermission('Announcements', null, null);
  const user = useSelector((state: any) => state.auth?.user || {});
  const roleName = user.roles[0].role.name;

  const showGeneral = !(
    roleName === USER_ROLES.SERVICE_PROVIDER ||
    roleName === USER_ROLES.SERVICE_MANAGER
  );

  return (
    <div className="inbox-header">
      <ul>
        <li>
          <a className={messageType} onClick={() => onSelectType('Messages')}>
            Messages
          </a>
        </li>
        {(showAnnouncement || showAnnouncementsForHomeowner !== undefined) && (
          <li>
            <a
              className={announcementType}
              onClick={() => onSelectType('Announcements')}
            >
              Announcements
            </a>
          </li>
        )}
        <li>
          <InboxMenu
            onSelectType={onSelectType}
            type={type}
            showGeneral={showGeneral}
          />
        </li>
      </ul>
    </div>
  );
};

export default InboxHeader;